const validatePhoneNumber = (value) => /^\d{3}-?\d{3}-?\d{4}$/.test(value);

export default validatePhoneNumber;
